import * as React from 'react';
import { view, createViewConfig } from '@sail/engine';
import { GridLines } from '../GridLines/GridLines';
import { styles } from './SectionStyles';
import { useHelmTheme } from '../../hooks/useHelmTheme';
export const SectionConfig = createViewConfig({
    props: {},
    name: 'Section',
    defaults: {
        padding: 'xlarge'
    }
});
/**
 * The top level component used to house content on Helm pages
 */ export const Section = SectionConfig.createView((props)=>{
    const { theme, flavor, accent, children, hasBorderTop, subviews, ...rest } = props;
    const themeTokenOverrideIntents = useHelmTheme({
        theme,
        flavor,
        accent
    });
    return /*#__PURE__*/ React.createElement(view.section, {
        ...rest,
        uses: [
            styles.sectionRoot,
            styles.sectionRootUnprocessed,
            ...themeTokenOverrideIntents
        ]
    }, /*#__PURE__*/ React.createElement(view.div, {
        uses: [
            styles.sectionMasked
        ]
    }, /*#__PURE__*/ React.createElement(view.div, {
        uses: [
            styles.sectionBackgroundMask
        ]
    }, /*#__PURE__*/ React.createElement(view.div, {
        uses: [
            styles.sectionBackground,
            hasBorderTop && styles.sectionBackgroundHasBorderTop
        ]
    }, /*#__PURE__*/ React.createElement(GridLines, null))), /*#__PURE__*/ React.createElement(view.div, {
        uses: styles.sectionContainer
    }, /*#__PURE__*/ React.createElement(view.div, {
        uses: styles.sectionLayoutContainer
    }, /*#__PURE__*/ React.createElement(view.div, {
        uses: styles.sectionLayout,
        inherits: subviews.sectionLayout
    }, props.children)))));
}, {
    variants: styles.variants
});

//# sourceMappingURL=Section.js.map